import { render, staticRenderFns } from "./SimUsage.vue?vue&type=template&id=5a1aa6ec&scoped=true"
import script from "./SimUsage.vue?vue&type=script&lang=js"
export * from "./SimUsage.vue?vue&type=script&lang=js"
import style0 from "./SimUsage.vue?vue&type=style&index=0&id=5a1aa6ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1aa6ec",
  null
  
)

export default component.exports